import { LogicalOperator, ValueExpression } from '@mtna/data-query-ui';

export class FilterGroup {
  constructor(public valueExpression?: ValueExpression, public groups?: FilterGroup[], public postOperator?: LogicalOperator) {}
}
